import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./menu-nav.styles.css";

const MenuArrow = () => (
  <svg className="menu-arrow" width="6" height="6" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5625 3.22427C8.14583 3.56904 8.14583 4.43096 7.5625 4.77573L2.3125 7.87866C1.72917 8.22343 1 7.79246 1 7.10293L1 0.897074C1 0.207534 1.72917 -0.223427 2.3125 0.121342L7.5625 3.22427Z" fill="#ffd177"/>
  </svg>
);

const navItems = [
  { label: "home", to: "/" },
  { label: "projects", to: "/projects" },
  { label: "about", to: "/about" },
  { label: "contact", to: "/contact" },
];

const MenuNav = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <nav className={`menu-new ${mobileOpen ? "open" : ""}`}>
        <div className="menu-item-wrapper">
          {navItems.map((item, i) => (
            <Link
              key={item.to}
              to={item.to}
              className={`menu-item ${i === 0 ? "left" : i === 1 ? "middle" : "right"}`}
              onClick={() => setMobileOpen(false)}
            >
              <MenuArrow />
              <div className="h4 y link">{item.label}</div>
            </Link>
          ))}
        </div>
      </nav>

      <button
        className="menu-mobile-toggle"
        aria-label="Toggle menu"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        <span />
        <span />
      </button>

      {mobileOpen && (
        <div className="menu-new-mobile">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="menu-new-mobile-item"
              onClick={() => setMobileOpen(false)}
            >
              <div className="h4 m y">{item.label}</div>
            </Link>
          ))}
        </div>
      )}
    </>
  );
};

export default MenuNav;
